export default function stringToHexColor(value: string) {
  value = value ?? ''
  const hash = Array.from(value).reduce(
    (hash, _, index) => value.charCodeAt(index) + ((hash << 5) - hash),
    0
  )

  return Array.from({ length: 3 }).reduce<string>((color, _, index) => {
    const value = (hash >> (index * 8)) & 0xff
    return color + `00${value.toString(16)}`.slice(-2)
  }, '#')
}
